import { get } from 'lodash-es';

//  do not display Installed Options & Packages module for Enterprise VDPs
export function hideOptions(vinData) {
  return get(vinData, 'dealerInfo.displayInfo.parentDealershipName', '') === 'Enterprise Car Sales';
}
